import React, { useContext } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Menu, MenuItem } from '@mui/material'
import useModals from 'src/Hooks/useModals'
import { EMobilityAccessRightsContext } from 'src/Libs/system-settings/provider/EMobilityAccessRightsContext'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'

interface TariffPricesModel {
  validFrom: number | null
  price: number
}

interface EMobilityWallboxMenuProps {
  isOpen: boolean
  anchorEl: null | HTMLElement
  handleClose: () => void
  wallboxName: string
  wallboxId: string
  storageId: string
  chargePrices: TariffPricesModel[]
  dischargePrices: TariffPricesModel[]
  wallboxIndex: number
  wallboxes: WallboxHardwareModel[]
  isEdisonConnect: boolean
}

const EMobilityWallboxMenu: React.FC<EMobilityWallboxMenuProps> = ({
  isOpen,
  anchorEl,
  handleClose,
  chargePrices,
  dischargePrices,
  wallboxName,
  wallboxId,
  storageId,
  wallboxIndex,
  wallboxes,
  isEdisonConnect,
}): JSX.Element => {
  const { openWallboxChargingSessionsOverview, openWallboxTariffsEditor } = useModals()
  const { t } = useCustomTranslation()
  const { hasEMobilityWritingRights } = useContext(EMobilityAccessRightsContext)

  return (
    <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
      <MenuItem
        onClick={() => {
          handleClose()
          openWallboxTariffsEditor({
            wallboxId,
            storageId: storageId,
            chargePrices,
            dischargePrices,
            wallboxName: wallboxName,
            wallboxIndex: wallboxIndex,
            isEdisonConnect,
          })
        }}
        disabled={!hasEMobilityWritingRights}
      >
        {t('emobility.wallbox.editWallbox')}
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleClose()
          openWallboxChargingSessionsOverview({ wallboxId, storageId, wallboxName, wallboxes })
        }}
      >
        {t('emobility.wallbox.viewChargingSessions')}
      </MenuItem>
    </Menu>
  )
}

export default EMobilityWallboxMenu
